import { render, staticRenderFns } from "./payments.pug?vue&type=template&id=63ab0a8b&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./payments.scss?vue&type=style&index=0&id=63ab0a8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab0a8b",
  null
  
)

export default component.exports